export const awsConfiguration = {
  localhost: {
    cognito: {
      aws_project_region: 'ap-south-1',
      aws_appsync_graphqlEndpoint:
        'https://dulmthdqkrg4zjngeex3dtwr3q.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_region: 'ap-south-1',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_cognito_identity_pool_id:
        'ap-south-1:0c7f6fd9-4488-4b47-a750-6c115e093ffb',
      aws_cognito_region: 'ap-south-1',
      aws_user_pools_id: 'ap-south-1_Fe6G8W1ay',
      aws_user_pools_web_client_id: '5jgo2oo0tcgc1d2j7u92a5c2mn',
      oauth: {},
      aws_cognito_username_attributes: ['EMAIL'],
      aws_cognito_social_providers: [],
      aws_cognito_signup_attributes: ['NAME'],
      aws_cognito_mfa_configuration: 'ON',
      aws_cognito_mfa_types: ['TOTP'],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [
          'REQUIRES_LOWERCASE',
          'REQUIRES_NUMBERS',
          'REQUIRES_SYMBOLS',
          'REQUIRES_UPPERCASE',
        ],
      },
      aws_cognito_verification_mechanisms: ['EMAIL'],
    },
    appSync: {
      aws_appsync_graphqlEndpoint:
        'https://xj2jrlz2nnhzhizrdx52h5575e.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_region: 'ap-south-1',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_apiKey: 'null',
    },
  },
  'sandbox-coral.dhi42cards.in': {
    cognito: {
      aws_project_region: 'ap-south-1',
      aws_appsync_graphqlEndpoint:
        'https://dulmthdqkrg4zjngeex3dtwr3q.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_region: 'ap-south-1',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_cognito_identity_pool_id:
        'ap-south-1:0c7f6fd9-4488-4b47-a750-6c115e093ffb',
      aws_cognito_region: 'ap-south-1',
      aws_user_pools_id: 'ap-south-1_Fe6G8W1ay',
      aws_user_pools_web_client_id: '5jgo2oo0tcgc1d2j7u92a5c2mn',
      oauth: {},
      aws_cognito_username_attributes: ['EMAIL'],
      aws_cognito_social_providers: [],
      aws_cognito_signup_attributes: ['NAME'],
      aws_cognito_mfa_configuration: 'ON',
      aws_cognito_mfa_types: ['TOTP'],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [
          'REQUIRES_LOWERCASE',
          'REQUIRES_NUMBERS',
          'REQUIRES_SYMBOLS',
          'REQUIRES_UPPERCASE',
        ],
      },
      aws_cognito_verification_mechanisms: ['EMAIL'],
    },
    appSync: {
      aws_appsync_graphqlEndpoint:
        'https://xj2jrlz2nnhzhizrdx52h5575e.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_region: 'ap-south-1',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_apiKey: 'null',
    },
  },
  'sandbox-caroline.dhi42cards.in': {
    cognito: {
      aws_project_region: 'ap-south-1',
      aws_cognito_identity_pool_id:
        'ap-south-1:ae56cf18-7c66-4aa9-ab05-7f115971db73',
      aws_cognito_region: 'ap-south-1',
      aws_user_pools_id: 'ap-south-1_GdwDMLTXX',
      aws_user_pools_web_client_id: '19qsmmstcb5jsaks2u0uh9vgfd',
      oauth: {},
      aws_cognito_username_attributes: ['EMAIL'],
      aws_cognito_social_providers: [],
      aws_cognito_signup_attributes: ['NAME'],
      aws_cognito_mfa_configuration: 'ON',
      aws_cognito_mfa_types: ['TOTP'],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [
          'REQUIRES_LOWERCASE',
          'REQUIRES_NUMBERS',
          'REQUIRES_SYMBOLS',
          'REQUIRES_UPPERCASE',
        ],
      },
      aws_cognito_verification_mechanisms: ['EMAIL'],
    },
    appSync: {
      aws_appsync_graphqlEndpoint:
        'https://vegrlhz4bvb6zcvesbnowr47qa.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_region: 'ap-south-1',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_apiKey: 'null',
    },
  },
  'caroline.dhi42cards.in': {
    cognito: {
      aws_project_region: 'ap-south-1',
      aws_cognito_identity_pool_id:
        'ap-south-1:d145651e-a418-4176-bb7e-63fa29234f2d',
      aws_cognito_region: 'ap-south-1',
      aws_user_pools_id: 'ap-south-1_9VLQmMFjg',
      aws_user_pools_web_client_id: '4sde7qsfmed9k2eidj70atiomr',
      oauth: {},
      aws_cognito_username_attributes: ['EMAIL'],
      aws_cognito_social_providers: [],
      aws_cognito_signup_attributes: ['NAME'],
      aws_cognito_mfa_configuration: 'ON',
      aws_cognito_mfa_types: ['TOTP'],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [
          'REQUIRES_LOWERCASE',
          'REQUIRES_NUMBERS',
          'REQUIRES_SYMBOLS',
          'REQUIRES_UPPERCASE',
        ],
      },
      aws_cognito_verification_mechanisms: ['EMAIL'],
    },
    appSync: {
      aws_appsync_graphqlEndpoint:
        'https://3cnqbrymtbaudneglt7m7c5siy.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_region: 'ap-south-1',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_apiKey: '',
    },
  },
  'coral.dhi42cards.in': {
    cognito: {
      aws_project_region: 'ap-south-1',
      aws_appsync_graphqlEndpoint:
        'https://6bwwfj2m5faqpocdyvwj3qrl6y.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_region: 'ap-south-1',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_cognito_identity_pool_id:
        'ap-south-1:0bc7ef86-e18f-4f56-813d-233c96357954',
      aws_cognito_region: 'ap-south-1',
      aws_user_pools_id: 'ap-south-1_CsGXEdMXG',
      aws_user_pools_web_client_id: '7dluh2fvnpsphppi15htaokc2b',
      oauth: {},
      aws_cognito_username_attributes: ['EMAIL'],
      aws_cognito_social_providers: [],
      aws_cognito_signup_attributes: ['NAME'],
      aws_cognito_mfa_configuration: 'ON',
      aws_cognito_mfa_types: ['TOTP'],
      aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [
          'REQUIRES_LOWERCASE',
          'REQUIRES_NUMBERS',
          'REQUIRES_SYMBOLS',
          'REQUIRES_UPPERCASE',
        ],
      },
      aws_cognito_verification_mechanisms: ['EMAIL'],
    },
    appSync: {
      aws_appsync_graphqlEndpoint:
        'https://kaerir3m35b5fjshhdcmc4xjue.appsync-api.ap-south-1.amazonaws.com/graphql',
      aws_appsync_region: 'ap-south-1',
      aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      aws_appsync_apiKey: '',
    },
  },
};
